<script lang="ts">
  import type { Transaction } from './types';

  export let transactions: Transaction[] = [];
  export let loading: boolean = false;
  export let loadError: string = '';
</script>

<div>
  {#if loading}
    Loading...
  {:else}
    <div>{loadError}</div>
    <table>
    {#each transactions as transaction}
      <tr>
        <td>{transaction.payee}</td>
        <td>{transaction.paydate}</td>
        <td class="right">{transaction.payamount}</td>
        <td class="left">{transaction.memo}</td>
      </tr>
    {/each}
    </table>
  {/if}
</div>

<style>
table, td {
  border: 1px solid black;
}

table {
  width: 100%;
  border-collapse: collapse;
}

td {
  padding: 0.25em 0.5em;
}

.left {
  text-align: left;
}

.right {
  text-align: right;
}
</style>